
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Prompt, Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import { Button, Row, Col, ButtonToolbar, ButtonGroup, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown, Nav, NavItem, NavLink } from 'reactstrap';
import { Formik, Field, Form, FieldArray } from 'formik';
import DocumentTitle from 'react-document-title';
import classNames from 'classnames';
import LoadingIcon from 'mdi-react/LoadingIcon';
import CheckIcon from 'mdi-react/CheckIcon';
import DatePicker from '../../components/custom/DatePicker';
import NaviBar from '../../components/custom/NaviBar';
import DropdownField from '../../components/custom/DropdownField';
import AutoCompleteField from '../../components/custom/AutoCompleteField';
import RintagiScreen from '../../components/custom/Screen';
import ModalDialog from '../../components/custom/ModalDialog';
import { showNotification } from '../../redux/Notification';
import { registerBlocker, unregisterBlocker } from '../../helpers/navigation'
import { isEmptyId, getAddDtlPath, getAddMstPath, getEditDtlPath, getEditMstPath, getNaviPath, getDefaultPath } from '../../helpers/utils'
import { toMoney, toLocalAmountFormat, toLocalDateFormat, toDate, strFormat } from '../../helpers/formatter';
import { setTitle, setSpinner, hideTopbarMenu, hideSidebar, registerTopbarLeft, registerTopbarCenter, registerTopbarRight } from '../../redux/Global';
import { RememberCurrent, GetCurrent } from '../../redux/Persist'
import { getNaviBar } from './index';
// import SubTestReduxObj from '../../redux/SubTest';
import Skeleton from 'react-skeleton-loader';
import ControlledPopover from '../../components/custom/ControlledPopover';
import log from '../../helpers/logger';
import { Elements, StripeProvider } from 'react-stripe-elements';
import StripeCheckoutForm from '../../components/custom/StripeCheckoutForm';
// import { loadPage as LoadOnboardingPage, submitOnboarding } from '../../redux/Onboarding';
// import VwRUsrSubDtlReduxObj, { ShowMstFilterApplied } from '../../redux/VwRUsrSubDtl';
import VwRUsrSubDtlReduxObj from '../../redux/VwRUsrSubDtl';
import RadioboxBlankIcon from 'mdi-react/RadioboxBlankIcon';
import CheckCircleIcon from 'mdi-react/CheckCircleIcon';
// import RSignUpSurveyReduxObj, { ShowMstFilterApplied } from '../../redux/RSignUpSurvey';
import RSignUpSurveyReduxObj, { ShowMstFilterApplied } from '../../redux/RSignUpSurvey';
import { isEmpty, isNotEmpty } from '../../helpers/utils';

class Onboarding extends RintagiScreen {
  constructor(props) {
    super(props);

    this.GetReduxState = ()=> (this.props.RSignUpSurvey || {});
    this.blocker = null;
    this.titleSet = false;
    this.MstKeyColumnName = 'SignUpSurveyId12';
    this.SystemName = 'Rintagi';
    this.confirmUnload = this.confirmUnload.bind(this);
    this.hasChangedContent = false;
    this.setDirtyFlag = this.setDirtyFlag.bind(this);
    this.AutoCompleteFilterBy = (option, props) => { return true };
    this.OnModalReturn = this.OnModalReturn.bind(this);
    this.mobileView = window.matchMedia('(max-width: 1200px)');
    this.mediaqueryresponse = this.mediaqueryresponse.bind(this);
    this.ValidatePage = this.ValidatePage.bind(this);

    this.state = {
      ScreenButton: null,
      initialing: true,
      Buttons: {},
      // currentOnboarding: {},
      currentQuestion: 'q1',
      key: Date.now(),
      ModalColor: "",
      ModalTitle: "",
      ModalHeader: false,
      ModalMsg: '',
      ModalOpen: false,
      ModalSuccess: null,
      submitting: false,
      isMobile: false,
      reduxRefreshed: false,
    }

    this.props.setSpinner(true);

    this.props.hideSidebar(true);
    this.props.hideTopbarMenu(true);
    this.props.registerTopbarLeft("","",false,"","");
    this.props.registerTopbarCenter(this.props.history.location.pathname, true, 'Finish setting up');
    // this.props.registerTopbarRight(this.Close.bind(this), this.props.history.location.pathname, true, 'close');

    Promise.all([
      this.props.LoadPage('MstRecord', { mstId: '!' }),
    ]).catch(error => {
      
    }).finally(() => {
      this.setState({ reduxRefreshed: true });
      setTimeout(() => this.props.setSpinner(false), 500);
      
    })

    if (!this.props.suppressLoadPage && this.props.history) {
      RememberCurrent('LastAppUrl', (this.props.history || {}).location, true);
    }

    if (!this.props.suppressLoadPage) {
      this.props.setSpinner(true);
    }
  }

  Close() {
    this.props.history.push('/dashboard');
  }

  mediaqueryresponse(value) {
    if (value.matches) { // if media query matches
      this.setState({ isMobile: true });
    }
    else {
      this.setState({ isMobile: false });
    }
  }

  subUsrId2InputChange() { const _this = this; return function (name, v) { const filterBy = ''; _this.props.SearchsubUsrId2(v, filterBy); } }/* ReactRule: Master Record Custom Function */
  /* ReactRule End: Master Record Custom Function */

  confirmUnload(message, callback) {
    const RSignUpSurveyState = this.props.RSignUpSurvey || {};
    const auxSystemLabels = RSignUpSurveyState.SystemLabel || {};
    const confirm = () => {
      callback(true);
    }
    const cancel = () => {
      callback(false);
    }
    this.setState({ ModalOpen: true, ModalSuccess: confirm, ModalCancel: cancel, ModalColor: 'warning', ModalTitle: auxSystemLabels.UnsavedPageTitle || '', ModalMsg: message });
  }

  setDirtyFlag(dirty) {
    /* this is called during rendering but has side-effect, undesirable but only way to pass formik dirty flag around */
    if (dirty) {
      if (this.blocker) unregisterBlocker(this.blocker);
      this.blocker = this.confirmUnload;
      registerBlocker(this.confirmUnload);
    }
    else {
      if (this.blocker) unregisterBlocker(this.blocker);
      this.blocker = null;
    }
    if (this.props.updateChangedState) this.props.updateChangedState(dirty);
    this.SetCurrentRecordState(dirty);
    return true;
  }

  ValidatePage(values) {
    const errors = {};
    /* Formik form submit validator, called WHENEVER it perform validation(default on every keystroke/lose focus), simplest place to grab the current set of values */
    log.debug('validate form', values);
    // this.setState({ currentOnboarding: { ...values } });

    /* validators go here but not recommended unless it doesn't fit in field based validation */

    if (this.state.currentQuestion === 'q1' &&
      !values.cRoleLs12) {
      errors.q1 = 'Please select at least one option that is suitable for you';
    }

    if (this.state.currentQuestion === 'q2' &&
      !values.cPurposeLs12) {
      errors.q2 = 'Please select at least one option that is suitable for you';
    }

    this.IsFormSubmit = false; // this is used by field validator and needs to be reset when we are here   
    this.FormGroup = undefined; // this is used by field validator and needs to be reset when we are here   

    return errors;
  }

  SubmitOnboarding = (values, { setSubmitting }) => {
    this.IsFormSubmit = false;
    this.setState({ submittedOn: Date.now(), submitting: true, setSubmitting: setSubmitting });

    log.debug(this.FormAction, values, { ...values });

    if (this.FormAction === "q1") {
      if (values.cRoleLs12) {
        this.setState({ currentQuestion: 'q2' });
      }
    }
    if (this.FormAction === "q2") {
      if (values.cPurposeLs12) {
        this.setState({ currentQuestion: 'q3' });
      }
    }
    if (this.FormAction === "q3") {
      this.setState({ currentQuestion: 'q4' });
    }
    else if (this.FormAction === 'q4') {
      this.props.setSpinner(true);
      // this.setState({ leavePage: true });
      // const revisedValuesAns1 = Object.keys(values).filter(x => typeof values[x] === "boolean" && values[x] !== false).filter(f => f.includes('ans1'));
      // const revisedValuesAns2 = Object.keys(values).filter(x => typeof values[x] === "boolean" && values[x] !== false).filter(f => f.includes('ans2'));

      // log.debug(revisedValuesAns1, revisedValuesAns2);
      const currMst = (this.props.RSignUpSurvey || {}).Mst || {};
      log.debug('save values:', values);
      const { ScreenButton, OnClickColumeName } = this;
      this.setState({submittedOn: Date.now(), submitting: true, setSubmitting: setSubmitting, key: currMst.key, ScreenButton: ScreenButton, OnClickColumeName: OnClickColumeName });
      this.ScreenButton = null;
      this.OnClickColumeName = null;
      this.props.SavePage(
        this.props.RSignUpSurvey,
        {
          SignUpSurveyId12: values.cSignUpSurveyId12|| '',
          UsrId12: values.cUsrId12 || ((this.props.VwRUsrSubDtl || {}).Mst || {}).UsrId4 || '',
          RoleLs12: values.cRoleLs12 || '',
          PurposeLs12: values.cPurposeLs12 || '',
          ExperienceId12: values.cExperienceId12 || '',
          OrgSizeId12: values.cOrgSizeId12 || '',
        },
        [],
        {
          persist: true,
          ScreenButton: (ScreenButton || {}).buttonType,
          OnClickColumeName: OnClickColumeName,
        }
      );

      this.setState({ key: Date.now() });

      // this.props.submitOnboarding({
      //   answer1: revisedValuesAns1,
      //   answer2: revisedValuesAns2,
      //   answer3: values.ans3,
      //   answer4: values.ans4,
      // })
      //   .then(() => {
      //     this.setState({ key: Date.now() });
      //   });
    }

    // this.FormAction = undefined;
  }

  componentDidMount() {
    this.mediaqueryresponse(this.mobileView);
    this.mobileView.addListener(this.mediaqueryresponse) // attach listener function to listen in on state changes
    const isMobileView = this.state.isMobile;
    const useMobileView = (isMobileView && !(this.props.user || {}).desktopView);
    const suppressLoadPage = this.props.suppressLoadPage;
    if (!suppressLoadPage) {
      const { mstId } = { ...this.props.match.params };
      // if (!(this.props.SubTest || {}).AuthCol || true) {
      //   this.props.LoadPage('Mst', { mstId: mstId || '_' });
      // }

      if (!(this.props.RSignUpSurvey || {}).AuthCol || true) {
        this.props.LoadPage('SearchList', { mstId: '!' });
        this.props.LoadInitPage({ keyId: null });
      }      

      if (!(this.props.VwRUsrSubDtl || {}).AuthCol || true) {
        this.props.LoadUserPage('SearchList', { mstId: '!' });
        this.props.LoadUserInitPage({ keyId: null });
      }
    }
    else {
      return;
    }
  }

  componentDidUpdate(prevProps, prevStates) {
    const currReduxScreenState = this.props.RSignUpSurvey || {};

    if (!this.props.suppressLoadPage) {
      if (!currReduxScreenState.page_loading && this.props.global.pageSpinner) {
        const _this = this;
        setTimeout(() => _this.props.setSpinner(false), 500);
      }
    }

    const currMst = currReduxScreenState.Mst || {};
    this.SetPageTitle(currReduxScreenState);
    if (prevStates.key !== currMst.key) {
      if ((prevStates.ScreenButton || {}).buttonType === 'SaveClose') {
        const currDtl = currReduxScreenState.EditDtl || {};
        const dtlList = (currReduxScreenState.DtlList || {}).data || [];
        const naviBar = getNaviBar('Mst', currMst, currDtl, currReduxScreenState.Label);
        const searchListPath = getDefaultPath(getNaviPath(naviBar, 'MstList', '/'))
        this.props.history.push(searchListPath);
      }
    }

    const currentReduxObj = this.props.onboarding || {};
    const previousReduxObj = prevProps.onboarding || {};
    const currentOnboarding = (currentReduxObj.currentOnboarding || {});
    const previousPayment = (previousReduxObj.currentOnboarding || {});

    if (this.state.submitting &&
      !(currentReduxObj.loading) &&
      ((previousReduxObj.key !== currentReduxObj.key) || currentReduxObj.status === "failed")
    ) {

      log.debug('##### 1');

      this.state.setSubmitting(false);
      if (currentReduxObj.status !== "failed") {
        log.debug(this.state.currentQuestion);
        if (this.state.leavePage) {
          log.debug('##### 2');
          this.redirecting = true;
          setTimeout(() => {
            if (this.redirecting) {
              log.debug('##### 3');
              this.props.history.push('/dashboard');
              setTimeout(() => { this.props.setSpinner(false) }, 0);
            }
            else {
              this.props.setSpinner(false);
            }
          }, 0);
        }
        else {
          this.setState({ submitting: false });
          this.props.setSpinner(false);
        }
      }
      else {
        this.setState({ submitting: false });
        this.props.setSpinner(false);
      }
    }
  }

  componentDidUpdate(prevprops, prevstates) {
    const currReduxScreenState = this.props.RSignUpSurvey || {};

    if (!this.props.suppressLoadPage) {
      if (!currReduxScreenState.page_loading && this.props.global.pageSpinner) {
        const _this = this;
        setTimeout(() => _this.props.setSpinner(false), 500);
      }
    }

    const currMst = currReduxScreenState.Mst || {};
    this.SetPageTitle(currReduxScreenState);
    if (prevstates.key !== currMst.key) {
      if ((prevstates.ScreenButton || {}).buttonType === 'SaveClose') {
        const currDtl = currReduxScreenState.EditDtl || {};
        const dtlList = (currReduxScreenState.DtlList || {}).data || [];
        const naviBar = getNaviBar('MstRecord', currMst, currDtl, currReduxScreenState.Label);
        const searchListPath = getDefaultPath(getNaviPath(naviBar, 'MstList', '/'))
        this.props.history.push(searchListPath);
      }
    }
  }

  componentWillUnmount() {
    if (this.blocker) {
      unregisterBlocker(this.blocker);
      this.blocker = null;
    }
    this.mobileView.removeListener(this.mediaqueryresponse);
  }

  render() {
    log.debug('surveyId', ((this.props.RSignUpSurvey || {}).Mst || {}).SignUpSurveyId12);

    if (this.state.reduxRefreshed && isNotEmpty(((this.props.RSignUpSurvey || {}).Mst || {}).SignUpSurveyId12)) {
      return <Redirect to='/dashboard' />;
    }
   

    // const reduxObj = this.props.plan || {};
    // const currentPlan = reduxObj.currentPlan;

    // const planUser = currentPlan.planUser;
    // const planName = currentPlan.planName;
    // const planPeriod = currentPlan.planPeriod;
    // const planPrice = currentPlan.planPrice;
    // const planCurrency = currentPlan.planCurrency;

    // const notPassedPlanInfo = (
      // this.state.reduxRefreshed &&
      // (this.props.user || {}).UsrId && !planPrice);

    // if (notPassedPlanInfo) {
    //   return <Redirect to='/dashboard' />;
    // }

    // const planNameLong = planName === 'E' ? 'Enterprise'
    //   : (planName === 'P' ? 'Professional'
    //     : (planName === 'C' ? 'Community' : 'Unknown'))

    const RSignUpSurveyState = this.props.RSignUpSurvey || {};

    if (RSignUpSurveyState.access_denied) {
      return <Redirect to='/error' />;
    }

    const screenHlp = RSignUpSurveyState.ScreenHlp;

    // Labels
    const siteTitle = (this.props.global || {}).pageTitle || '';
    const MasterRecTitle = ((screenHlp || {}).MasterRecTitle || '');
    const MasterRecSubtitle = ((screenHlp || {}).MasterRecSubtitle || '');

    const screenButtons = RSignUpSurveyReduxObj.GetScreenButtons(RSignUpSurveyState) || {};
    const itemList = RSignUpSurveyState.Dtl || [];
    const auxLabels = RSignUpSurveyState.Label || {};
    const auxSystemLabels = RSignUpSurveyState.SystemLabel || {};

    const columnLabel = RSignUpSurveyState.ColumnLabel || {};
    const authCol = this.GetAuthCol(RSignUpSurveyState);
    const authRow = (RSignUpSurveyState.AuthRow || [])[0] || {};
    const currMst = ((this.props.RSignUpSurvey || {}).Mst || {});
    const currDtl = ((this.props.RSignUpSurvey || {}).EditDtl || {});
    const naviBar = getNaviBar('MstRecord', currMst, currDtl, screenButtons).filter(v => ((v.type !== 'DtlRecord' && v.type !== 'DtlList') || currMst.SignUpSurveyId12));
    const selectList = RSignUpSurveyReduxObj.SearchListToSelectList(RSignUpSurveyState);
    const selectedMst = (selectList || []).filter(v => v.isSelected)[0] || {};


    const { dropdownMenuButtonList, bottomButtonList, hasDropdownMenuButton, hasBottomButton, hasRowButton } = this.state.Buttons;
    const hasActableButtons = hasBottomButton || hasRowButton || hasDropdownMenuButton;

    const isMobileView = this.state.isMobile;
    const useMobileView = (isMobileView && !(this.props.user || {}).desktopView);
    /* ReactRule: Master Render */
    /* ReactRule End: Master Render */

    const SignUpSurveyId12 = currMst.SignUpSurveyId12 || "";
    const UsrId12 = currMst.UsrId12 || "";
    
    const RoleLs12 = currMst.RoleLs12 || "";
    const selectedRole = RoleLs12.length > 0 ? RoleLs12.replace('(', '').replace(')', '').split(',') : [];
    const RoleLs12List = RSignUpSurveyReduxObj.ScreenDdlSelectors.RoleLs12(RSignUpSurveyState).filter(o=>o.value).map(o=>({...o, checked: selectedRole.filter(v=>v == o.value).length > 0 }));

    const PurposeLs12 = currMst.PurposeLs12 || "";
    const selectedPurpose = PurposeLs12.length > 0 ? PurposeLs12.replace('(', '').replace(')', '').split(',') : [];
    const PurposeLs12List = RSignUpSurveyReduxObj.ScreenDdlSelectors.PurposeLs12(RSignUpSurveyState).filter(o=>o.value).map(o=>({...o, checked: selectedPurpose.filter(v=>v == o.value).length > 0 }));
    
    const ExperienceId12 = currMst.ExperienceId12 || "";
    const ExperienceId12List = RSignUpSurveyReduxObj.ScreenDdlSelectors.ExperienceId12(RSignUpSurveyState).filter(o=>o.value);
    
    const OrgSizeId12 = currMst.OrgSizeId12 || "";
    const OrgSizeId12List = RSignUpSurveyReduxObj.ScreenDdlSelectors.OrgSizeId12(RSignUpSurveyState).filter(o=>o.value);

    return (
      <DocumentTitle title={siteTitle}>
        <div>
          <ModalDialog color={this.state.ModalColor} title={this.state.ModalTitle} onChange={this.OnModalReturn} ModalOpen={this.state.ModalOpen} message={this.state.ModalMsg} />
          <div className='account'>
            <div className='account__wrapper account-full-width'>
              <div className='account__card'>
                <div>
                  <div className="account-narrow">
                    <Formik
                      initialValues={
                        {
                          cSignUpSurveyId12: SignUpSurveyId12 || '',
                          cUsrId12: UsrId12 || '',
                          cRoleLs12: RoleLs12,
                          cPurposeLs12: PurposeLs12,
                          cExperienceId12: ExperienceId12,
                          cOrgSizeId12: OrgSizeId12,
                        }
                      }
                      key={currMst.key}
                      // validateOnChange={true}
                      // validateOnBlur={true}
                      validate={this.ValidatePage}
                      onSubmit={this.SubmitOnboarding}
                      render={({
                        values,
                        errors,
                        touched,
                        isSubmitting,
                        dirty,
                        setFieldValue,
                        setFieldTouched,
                        handleChange,
                        submitForm,
                        setFieldError,
                      }) => (
                          <div>
                            {this.setDirtyFlag(dirty) &&
                              <Prompt
                                when={dirty}
                                message={auxSystemLabels.UnsavedPageMsg || ''}
                              />
                            }
                            <Form className='form'>
                              <div className='w-100'>
                                <h4 className='account__subhead subhead mb-30'>We have 4 quick questions to get to know you a little better so we can better cater to your experience.</h4>
                                {this.state.currentQuestion === 'q1' && <div>
                                  <div className="onboarding-card">
                                    <p className="payment-card-sub-price text-left mb-20">Question 1 of 4</p>
                                    <h4 className='account__subhead mb-20'>What best describes your role?</h4>
                                    {RoleLs12List.map((obj, i) => (
                                      <div className='form__form-group' key={i}>
                                        <label className='checkbox-btn checkbox-btn--colored-click'>
                                          <Field
                                            name={"RoleLs12" + "_" + obj.value}
                                            value={obj.value}
                                            type="checkbox"
                                            listidx={i}
                                            keyid={obj.key}
                                            className='checkbox-btn__checkbox'
                                            disabled={obj.disabled}
                                            onClick={this.CheckListChange(setFieldValue, setFieldTouched, "cRoleLs12", obj.value, values)}
                                            checked={this.BindCheckListField(obj.value, values.cRoleLs12 )}
                                          />
                                          <span className='checkbox-btn__checkbox-custom'><CheckIcon /></span>
                                          <span className='checkbox-btn__label'>{obj.label}</span>
                                        </label>
                                      </div>))}
                                  </div>
                                  {errors.q1 && <span className='form__form-group-error'>{errors.q1}</span>}
                                  <Row className="mt-30 mb-10">
                                    <Col>
                                      <Button
                                        color="success"
                                        type="submit"
                                        className="btn btn-success rounded account__btn mw-flex-50 btn-centered"
                                        onClick={this.SubmitForm('q1')}>
                                        Continue</Button>
                                    </Col>
                                  </Row>
                                </div>
                                }
                                {this.state.currentQuestion === 'q2' && <div>
                                  <div className="onboarding-card">
                                    <p className="payment-card-sub-price text-left mb-20">Question 2 of 4</p>
                                    <h4 className='account__subhead mb-20'>What are you using Rintagi for?</h4>
                                    {PurposeLs12List.map((obj, i) => (
                                      <div className='form__form-group' key={i}>
                                        <label className='checkbox-btn checkbox-btn--colored-click'>
                                          <Field
                                            name={"PurposeLs12" + "_" + obj.value}
                                            value={obj.value}
                                            type="checkbox"
                                            listidx={i}
                                            keyid={obj.key}
                                            className='checkbox-btn__checkbox'
                                            disabled={obj.disabled}
                                            onClick={this.CheckListChange(setFieldValue, setFieldTouched, "cPurposeLs12", obj.value, values)}
                                            checked={this.BindCheckListField(obj.value, values.cPurposeLs12 )}
                                          />
                                          <span className='checkbox-btn__checkbox-custom'><CheckIcon /></span>
                                          <span className='checkbox-btn__label'>{obj.label}</span>
                                        </label>
                                      </div>))}
                                  </div>
                                  {errors.q2 && <span className='form__form-group-error'>{errors.q2}</span>}
                                  <Row className="mt-30 mb-10">
                                    <Col>
                                      <Button
                                        color="success"
                                        type="submit"
                                        className="btn btn-success rounded account__btn mw-flex-50 btn-centered"
                                        onClick={this.SubmitForm('q2')}>
                                        Continue</Button>
                                    </Col>
                                  </Row>
                                </div>
                                }
                                {this.state.currentQuestion === 'q3' && <div>
                                  <div className="onboarding-card pb-15">
                                    <p className="payment-card-sub-price text-left mb-20">Question 3 of 4</p>
                                    <h4 className='account__subhead mb-20'>Do you have experience using low code development platforms?</h4>
                                    {ExperienceId12List.map((obj, i) => {
                                      return (
                                        <div className='form__form-group-narrow' key={i}>
                                          <div className='form__form-group-field'>
                                            <label className='radio-btn radio-btn--button margin-narrow'>
                                              <Field
                                                className='radio-btn__radio'
                                                name='cExperienceId12'
                                                type='radio'
                                                listidx={i}
                                                keyid={obj.key}
                                                value={obj.value}
                                                validate={this.RequiredField({ setFieldValue, setFieldTouched, values, name: 'cExperienceId12', message: "Please select one option that is suitable for you" })}
                                                onClick={this.RadioChange(setFieldValue, setFieldTouched, 'cExperienceId12', ExperienceId12List)}
                                                checked={this.BindRadioField(obj.value, values.cExperienceId12)}
                                              />
                                              <span className="radio-btn__label-svg pr-30">
                                                <CheckCircleIcon className='radio-btn__label-check' />
                                                <RadioboxBlankIcon className='radio-btn__label-uncheck' />
                                              </span>
                                              <span className='radio-btn__label'>
                                                <div>{obj.label}</div>
                                              </span>
                                            </label>
                                          </div>
                                        </div>
                                      )
                                    })}
                                    {/* {errors.ans3 && touched.ans3 && <span className='form__form-group-error plr-15'>{errors.ans3}</span>} */}
                                  </div>
                                  {errors.ans3 && <span className='form__form-group-error'>{errors.ans3}</span>}
                                  <Row className="mt-30 mb-10">
                                    <Col>
                                      <Button
                                        color="success"
                                        type="submit"
                                        className="btn btn-success rounded account__btn mw-flex-50 btn-centered"
                                        onClick={this.SubmitForm('q3')}>
                                        Continue</Button>
                                    </Col>
                                  </Row>
                                </div>
                                }
                                {this.state.currentQuestion === 'q4' && <div>
                                  <div className="onboarding-card pb-15">
                                    <p className="payment-card-sub-price text-left mb-20">Question 4 of 4</p>
                                    <h4 className='account__subhead mb-20'>What is the size of your organization?</h4>
                                    {OrgSizeId12List.map((obj, i) => {
                                      return (
                                        <div className='form__form-group-narrow' key={i}>
                                          <div className='form__form-group-field'>
                                            <label className='radio-btn radio-btn--button margin-narrow'>
                                              <Field
                                                className='radio-btn__radio'
                                                name='cOrgSizeId12'
                                                type='radio'
                                                listidx={i}
                                                keyid={obj.key}
                                                value={obj.value}
                                                validate={this.RequiredField({ setFieldValue, setFieldTouched, values, name: 'cOrgSizeId12', message: "Please select one option that is suitable for you" })}
                                                onClick={this.RadioChange(setFieldValue, setFieldTouched, 'cOrgSizeId12', OrgSizeId12List)}
                                                checked={this.BindRadioField(obj.value, values.cOrgSizeId12)}
                                              />
                                              <span className="radio-btn__label-svg pr-30">
                                                <CheckCircleIcon className='radio-btn__label-check' />
                                                <RadioboxBlankIcon className='radio-btn__label-uncheck' />
                                              </span>
                                              <span className='radio-btn__label'>
                                                <div>{obj.label}</div>
                                              </span>
                                            </label>
                                          </div>
                                        </div>
                                      )
                                    })}
                                    {/* {errors.ans3 && touched.ans3 && <span className='form__form-group-error plr-15'>{errors.ans3}</span>} */}
                                  </div>
                                  {errors.ans4 && <span className='form__form-group-error'>{errors.ans4}</span>}
                                  <Row className="mt-30 mb-10">
                                    <Col>
                                      <Button
                                        color="success"
                                        type="submit"
                                        className="btn btn-success rounded account__btn mw-flex-50 btn-centered"
                                        onClick={this.SubmitForm('q4')}>
                                        Continue</Button>
                                    </Col>
                                  </Row>
                                </div>
                                }
                              </div>
                            </Form>
                          </div>
                        )}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </DocumentTitle>
    );
  };
};

const mapStateToProps = (state) => ({
  user: (state.auth || {}).user,
  error: state.error,
  // SubTest: state.SubTest,
  global: state.global,
  // onboarding: state.onboarding,
  plan: state.plan,
  VwRUsrSubDtl: state.VwRUsrSubDtl,
  RSignUpSurvey: state.RSignUpSurvey,
});

const mapDispatchToProps = (dispatch) => (
  bindActionCreators(Object.assign({},
    // { LoadOnboardingPage: LoadOnboardingPage },
    // { submitOnboarding: submitOnboarding },
    // { LoadPage: SubTestReduxObj.LoadPage.bind(SubTestReduxObj) },
    { LoadPage: RSignUpSurveyReduxObj.LoadPage.bind(RSignUpSurveyReduxObj) },
    { LoadInitPage: RSignUpSurveyReduxObj.LoadInitPage.bind(RSignUpSurveyReduxObj) },
    { LoadUserPage: VwRUsrSubDtlReduxObj.LoadPage.bind(VwRUsrSubDtlReduxObj) },
    { LoadUserInitPage: VwRUsrSubDtlReduxObj.LoadInitPage.bind(VwRUsrSubDtlReduxObj) },
    // { LoadSearchList: VwRUsrSubDtlReduxObj.LoadSearchList.bind(VwRUsrSubDtlReduxObj) },
    // { SavePage: SubTestReduxObj.SavePage.bind(SubTestReduxObj) },
    { SavePage: RSignUpSurveyReduxObj.SavePage.bind(RSignUpSurveyReduxObj) },
    { DelMst: RSignUpSurveyReduxObj.DelMst.bind(RSignUpSurveyReduxObj) },
    { AddMst: RSignUpSurveyReduxObj.AddMst.bind(RSignUpSurveyReduxObj) },
    // { DelMst: SubTestReduxObj.DelMst.bind(SubTestReduxObj) },
    // { AddMst: SubTestReduxObj.AddMst.bind(SubTestReduxObj) },
    //    { SearchMemberId64: SubTestReduxObj.SearchActions.SearchMemberId64.bind(SubTestReduxObj) },
    //    { SearchCurrencyId64: SubTestReduxObj.SearchActions.SearchCurrencyId64.bind(SubTestReduxObj) },
    //    { SearchCustomerJobId64: SubTestReduxObj.SearchActions.SearchCustomerJobId64.bind(SubTestReduxObj) },
    // { SearchsubUsrId2: SubTestReduxObj.SearchActions.SearchsubUsrId2.bind(SubTestReduxObj) },
    { showNotification: showNotification },
    { setTitle: setTitle },
    { setSpinner: setSpinner },
    { hideSidebar: hideSidebar },
    { hideTopbarMenu: hideTopbarMenu },
    { registerTopbarLeft: registerTopbarLeft },
    { registerTopbarCenter: registerTopbarCenter },
    { registerTopbarRight: registerTopbarRight },
  ), dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(Onboarding);




// WEBPACK FOOTER //
// ./src/pages/Custom/Onboarding.js